import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-big-boss',
  templateUrl: './big-boss.component.html',
  styleUrls: ['./big-boss.component.scss']
})
export class BigBossComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
